export var LocationType;
(function (LocationType) {
    LocationType["Departure"] = "departure";
    LocationType["Arrival"] = "arrival";
})(LocationType || (LocationType = {}));
